import { Shape } from '@tokamap/core';

export default function shapePlaceId(shape: Shape): string | undefined {
	const id = (shape.entity as any)?.entity?.id;

	return id === undefined || id === null || id === '' ? undefined : String(id);
}
